"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAmplitudeTracker = useAmplitudeTracker;
var _analyticsBrowser = require("@amplitude/analytics-browser");
var _services = require("../services");
/* eslint-disable @typescript-eslint/no-explicit-any */

let lastPathname = null;
function useAmplitudeTracker() {
  function trackEvent(name, {
    pathname: _pathname,
    ...properties
  } = {}) {
    const currentUser = _services.UserService.currentUser;
    const pathname = _pathname?.replace(/\/$/, '');
    if (name !== 'Page Visited' || pathname !== undefined && (lastPathname === null || pathname.localeCompare(lastPathname) !== 0)) {
      (0, _analyticsBrowser.track)(name, {
        user_id: currentUser?.id,
        is_staff: currentUser?.isGeovelo || currentUser?.isEcoCompteur,
        ...properties,
        pathname,
        env: process.env.REACT_APP_ENV || process.env.GATSBY_APP_ENV
      });
      if (name === 'Page Visited' && pathname !== undefined) lastPathname = pathname;
    }
  }
  return {
    trackEvent
  };
}